import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

const CharacterCounter = ({ value, max }) => {
  const length = value?.length ?? 0
  const isWarn = length >= max * 0.9

  return (
    <span
      className={classNames("mt-1 text-xs", {
        "text-amber-600": isWarn,
        "text-gray-500": !isWarn,
      })}
    >
      {length} / {max}
    </span>
  )
}

CharacterCounter.propTypes = {
  value: PropTypes.string,
  max: PropTypes.number.isRequired,
}

export default CharacterCounter
